import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/login/login-page';
import OtpLogin from './components/otp-login/otp-login.js';
import FaceLogin from './components/face-login/face-login.js';
import { global_var } from "../src/services/login-config.js";
import { getCompanyDetails, userTokenAuthentication, getCompanySettings } from "../src/services/login-api.js";
import CsproLogin from './components/login/cspro_login';
import GoogleSignIn from './components/login/google_sign_in';
import { Spin } from 'antd';
// import BrowserDetectionModal from './components/modal/browserDetection-modal.js';
import ProfileSetup from './components/profile-setup/profile-setup.js';
import StudentRegistration from './components/profile-setup/student-registration.js';
import CompanyRegistration from './components/profile-setup/company-registration.js';
import { setCompanyDetails } from './utils/setCompanyDetails'; // Corrected import path
import ExternalCompanyRegistration from './components/profile-setup/external-company-registration.js';

function App() {
  const [loading, setLoading] = useState(true);
  // const [showModal, setShowModal] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [favIcon, setFavicon] = useState(null);

  useEffect(() => {
    // const isChromium = window.chrome;
    // const winNav = window.navigator;
    // const vendorName = winNav.vendor;
    // const isOpera = typeof window.opr !== "undefined";
    // const isIEedge = winNav.userAgent.indexOf("Edg") > -1;
    // const isIOSChrome = winNav.userAgent.match("CriOS");
    // const isSafari = /^((?!chrome|android).)*safari/i.test(winNav.userAgent);

    // if (!(isSafari || isIOSChrome || (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false))) {
    //   setShowModal(true);
    // }

    const logout = new URLSearchParams(window.location.search).get('logout');
    if (logout === 'true') {
      localStorage.removeItem('token');
    } else {
      const token = localStorage.getItem('token');
      if (token) {
        userTokenAuthentication(token).then((response) => {
          if (response.statusCode === 200) {
            let domainName = 'https://' + window.location.host.replace(/.login/g, '');
            const currentUrl = new URL(window.location.href);
            const queryParams = new URLSearchParams(currentUrl.search);
            if (response.userDetails.roleId === '3' || response.userDetails.roleName === "Mentee") {
              domainName += '/candidate/#/home/redirect';
            } else {
              domainName += '/company/#/home/redirect';
            }
            domainName += '?access_token=' + token;

            if (global_var.dashboard_url && response.userDetails?.roleId !== '3') {
              if (queryParams.has('redirectTo')) {
                const redirectToValue = queryParams.get('redirectTo');
                domainName = 'https://' + global_var.dashboard_url + redirectToValue + '?token=' + token;
              } else {
                domainName = 'https://' + global_var.dashboard_url + '?token=' + token;
              }
            }

            window.location.href = domainName;
          } else {
            localStorage.removeItem('token');
          }
        });
      }
    }

    if (window.location.host.split(".").length) {
      let domainName = window.location.host.split('.')[0];
      getCompanyDetails({domainName}).then((response) => {
        setLoading(false);
    
        if (response.company_obj && response.company_obj.result === 'Exists') {
          const data = response.company_obj;
          setCompanyDetails(data, global_var, setCompanyName, setFavicon);

          if (global_var.companyId) {
            fetchCompanySettings(global_var.companyId);
          }
        } else {
          console.error("Company not found");
        }
        
      });
    }

    const fetchCompanySettings = async (companyId) => {
      const response = await getCompanySettings(companyId);
      if (response.statusCode === 200) {

        global_var.enableFaceLogin = response.companyDetails.companySettings.enableFaceLogin ? response.companyDetails.companySettings.enableFaceLogin : false;

        if (response.companyDetails.companySettings.loginPageConf) {
          global_var.loginPageConf = response.companyDetails.companySettings.loginPageConf;
        }
      }
    };


  }, []);

  useEffect(() => {
    document.title = companyName;
    if (favIcon) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = favIcon;
      document.head.appendChild(link);
    }
  }, [companyName, favIcon]);

  return (
    <BrowserRouter>
      {loading ? (
        <div className="spinner-container">
          <Spin size="large" />
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/otpLogin" element={<OtpLogin />} />
          <Route path="/faceLogin" element={<FaceLogin />} />
          <Route path="*" element={<Navigate to="/login" />} />
          <Route path="/cspro_login" element={<CsproLogin />} />
          <Route path="/google_sign" element={<GoogleSignIn />} />
          <Route path="/profile-setup" element={<ProfileSetup />} />
          <Route path="/joinCybersquare/:ecryptedData" element={<StudentRegistration />} />
          <Route path="/companyRegistration" element={<CompanyRegistration />} />
          <Route path="/externalCompanyRegistration" element={<ExternalCompanyRegistration />} />
        </Routes>
      )}
  </BrowserRouter>
  );
}

export default App;
